import { combineReducers } from 'redux';

import agendaReducer from './agenda/agenda.reducer';
import clientReducer from './client/client.reducer';
import groupReducer from './group/group.reducer';
import locationReducer from './location/location.reducer';
import notificationsReducer from './notifications/notifications.reducer';
import schemaDataReducer from './schema-data/schema-data.reducer';
import settingsReducer from './settings/settings.reducer';

export default combineReducers({
    agenda: agendaReducer,
    client: clientReducer,
    group: groupReducer,
    location: locationReducer,
    notifications: notificationsReducer,
    schemaData: schemaDataReducer,
    settings: settingsReducer
});